module.exports = __webpack_public_path__ + "img/user-flat.877a015e.svg";